import { useQuery } from "@tanstack/react-query";
import { type RouterOutputs, useTRPC } from "./trpc";

export type SystemInfo = RouterOutputs["system"]["info"];
export type Capabilities = SystemInfo["capabilities"];

/** The server's version and what this host allows (demo packages, new garages …). */
export function useSystemInfo(): SystemInfo | undefined {
  const trpc = useTRPC();
  return useQuery({ ...trpc.system.info.queryOptions(), staleTime: Number.POSITIVE_INFINITY }).data;
}
